<template>
  <div class="charts-progress">
    <div class="charts-progress-info">
      <h4>
        <b>{{ getPercentage() }}</b
        >%
      </h4>
      <p>{{ $l("当前进度") }}</p>
    </div>
    <div class="charts-progress-chart__canvas" :id="id">
      <el-progress
        type="circle"
        :percentage="getPercentage()"
        :width="175"
        :show-text="false"
        :color="colorPrimary"
      >
      </el-progress>
    </div>
  </div>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "chartsProgress",
  mixins: [global],
  props: {
    data: Object,
    id: String,
  },
  data() {
    return {
      myChart: null,
      sdata: {
        sum: 2344,
        value: 234,
      },
    };
  },
  methods: {
    setId: function () {
      return "charts-progress-chart__" + this.index;
    },
    getPercentage() {
      if (this.sdata.sum == 0) {
        return Number(0);
      }
      return Number(((this.sdata.value / this.sdata.sum) * 100).toFixed(1));
    },
  },
  computed: {},
  watch: {
    data(val) {
      if (val) {
        this.sdata = val;
      }
    },
  },
  mounted() {
    if (this.data) {
      this.sdata = this.data;
    }
  },
};
</script>

<style scoped lang="scss">
.charts-progress {
  width: 100%;
  height: 100%;
  margin: 0 auto;

  &-chart {
    &__canvas {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  &-info {
    position: absolute;
    width: 200px;
    height: 200px;
    left: 50%;
    top: 50%;
    margin-left: -100px;
    margin-top: -100px;
    border-radius: 50%;
    border: 1px solid $--border-color-base;
    // padding: 0 30px;
    font-size: $--font-size-small;
    text-align: center;
    padding-top: 68px;
    h4 {
      // color: $--color-text-regular;
      font-size: $--font-size-large;
      line-height: 1;
      margin-right: -0.4em;
      b {
        font-size: 45px;
        font-weight: normal;
        color: $--color-text-primary;
        margin-right: 5px;
      }
    }
    p {
      line-height: 2.2;
    }
  }
}
.el-progress /deep/ svg {
  path:first-child {
    stroke: #fff;
  }
}

@media screen and (max-width: 1600px) {
  .charts-progress-info {
    width: 160px;
    height: 160px;
    margin-left: -80px;
    margin-top: -80px;
    padding-top: 50px;
    h4 b {
      font-size: 39px;
    }
  }
  /deep/ .el-progress-circle {
    width: 140px !important;
    height: 140px !important;
  }
}
</style>
